import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet, ChildrenOutletContexts } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { Header } from './components/header/header';
import { Sidebar } from './components/sidebar/sidebar';
import { Quickpanel } from './components/quickpanel/quickpanel';
import { Navigation } from './components/navigation/navigation';
import { Footer } from './components/footer/footer';
import { LoadingBar } from '@shared/components/loading-bar/loading-bar';
import { LayoutService } from '@core/services/layout.service';
import { routeAnimation, fadeIn, scaleIn } from '@core/animations/route.animations';

@Component({
  selector: 'app-shell',
  imports: [
    RouterOutlet,
    Header,
    Sidebar,
    Quickpanel,
    Navigation,
    Footer,
    LoadingBar,
    MatButtonModule,
    MatIconModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [routeAnimation, fadeIn, scaleIn],
  templateUrl: './shell.html',
})
export class Shell {
  readonly layout = inject(LayoutService);
  private readonly contexts = inject(ChildrenOutletContexts);

  getRouteAnimationData(): string {
    return this.contexts.getContext('primary')?.route?.snapshot?.url?.toString() ?? '';
  }
}
